import React, { useState } from "react";
import { Box, Button } from "@mui/material";
import DynamicTableForJson from "../../../../../data/DynamicTable/dynamicTableForJson";
import { customerservice } from "../../../../../config";
import NOKForm from "./form";
import { useNavigate } from "react-router-dom";
import Joyride from "react-joyride"; // Import Joyride

const base_url = customerservice.uri;

// Define Joyride tour steps
const rightsTourSteps = [
  {
    target: ".dynamic-table-header",
    content: "This is the Next of Kin Management page, where you can manage a customer's next of kin details.",
    placement: "top",
    disableBeacon: true,
  },
  {
    target: ".dynamic-table-search",
    content: "Use the search bar to find a specific next of kin by name or other criteria.",
    placement: "bottom",
  },
  {
    target: ".dynamic-table-add-button",
    content: "Click this button to add a new next of kin.",
    placement: "right",
  },
  {
    target: ".dynamic-table-actions",
    content: "Select actions like Edit or Deactivate for each next of kin from this dropdown.",
    placement: "left",
  },
];

const NOKTable = () => {
  const [runTour, setRunTour] = useState(false); // ▶️ State to control Joyride

  const customerId = localStorage.getItem("CustomerId");
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const userId = parseInt(decodedToken.Id);
  const navigate = useNavigate();
  const customerstatus = parseInt(localStorage.getItem("Status") || 0);
  const showButton = customerstatus === 1 || customerstatus === 0 || localStorage.getItem("Status") === null;

  const actions = {
    entity: "Next Of Kin",
    isSubright: true,
    edit: {
      key: "EDIT",
      button_name: "Edit",
      Show_Button: showButton,
      permission: "EditPermission",
    },
    add: {
      key: "ADD",
      button_name: "Add",
      Show_Button: showButton,
      permission: "CreatePermission",
    },
    dataObject: {
      ignoreFields: [
        "UpdateDate",
        "CreateDate",
        "VerifiedBy",
        "VerifiedDate",
        "HouseName",
        "FloorNumber",
        "RoomNumber",
        "DateCreated",
        "NextOfKinPhoto",
        "NextOfKinIdPhoto",
        "Town",
        "PermanentResidence",
        "Dob",
        "NextOfKinRelationship",
        "MaritalStatus",
      ],
      objectName: "nextOfKinById",
      parameters: { customerId: parseInt(customerId) },
      inputObjectName: "nextOfKin",
    },
  };

  return (
    <Box m="20px">
      {/* Joyride Component */}
      <Joyride
        steps={rightsTourSteps}
        run={runTour}
        continuous
        showSkipButton
        showProgress
        styles={{
          options: {
            primaryColor: "#1976d2",
            zIndex: 10000,
          },
        }}
      />

      {/* Top Bar */}
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Button onClick={() => navigate(-1)} variant="contained">
          Back to Customers
        </Button>
        <Button onClick={() => setRunTour(true)} variant="outlined" color="primary">
          Start Page Tour
        </Button>
      </Box>

      <DynamicTableForJson
        title="NOK"
        subtitle="Manage Next of Kin"
        FormComponent={NOKForm}
        base_url={base_url}
        actions={actions}
        tourSteps={rightsTourSteps} // Still passed in case DynamicTable needs it
      />
    </Box>
  );
};

export default NOKTable;
